import { render, staticRenderFns } from "./TableVideoItem.vue?vue&type=template&id=39157132&scoped=true"
import script from "./TableVideoItem.vue?vue&type=script&lang=js"
export * from "./TableVideoItem.vue?vue&type=script&lang=js"
import style0 from "./TableVideoItem.vue?vue&type=style&index=0&id=39157132&scoped=true&lang=css"
import style1 from "./TableVideoItem.vue?vue&type=style&index=1&id=39157132&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39157132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39157132')) {
      api.createRecord('39157132', component.options)
    } else {
      api.reload('39157132', component.options)
    }
    module.hot.accept("./TableVideoItem.vue?vue&type=template&id=39157132&scoped=true", function () {
      api.rerender('39157132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TableVideoItem.vue"
export default component.exports